import React from 'react';
import { Box, Typography } from '@mui/material';

type LocalRawFileMessageProps = {
  icon: React.ReactNode;
  channelGuid: string;
  messageGuid: string;
  fileName?: string;
};

export const LocalRawFileMessage = (props: LocalRawFileMessageProps) => {
  const { icon, fileName } = props;
  return (
    <Box sx={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
      {icon}
      <Typography
        color='primary'
        sx={{
          color: '#ACCCF3',
          fontSize: 14,
          pl: 1,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {fileName}
      </Typography>
    </Box>
  );
};
